import "./App.css";
import Routes from "./Routes/Routes";
import CacheBuster from "react-cache-buster";
import packageJson from "../package.json";
import FullScreenLoading from "./Components/Loading/FullScreenLoading";
import AppVersionChecker from "./Components/AppVersionChecker";
import { MinimizedModalHost } from "./Components/Modal/Modal";

// Each tag changes this browser version while vendor bundles keep their hashes.
const buildVersion =
  process.env.REACT_APP_BUILD_VERSION || `${packageJson.version}.0`;

function App() {
  const isProduction = process.env.NODE_ENV === "production";

  return (
    <CacheBuster
      currentVersion={buildVersion}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<FullScreenLoading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
      reloadOnDowngrade={true} //Reload when the deployed version is different, including a rollback.
    >
      {isProduction ? <AppVersionChecker /> : null}
      <div className="Page">
        <MinimizedModalHost />
        <Routes />
      </div>
    </CacheBuster>
  );
}

export default App;
